export default {
  passengerWireToInt: passengerWireToInt,
  passengerIntToWire: passengerIntToWire,
  passengersWireToInt: passengersWireToInt,
  passengersIntToWire: passengersIntToWire,
};

function passengersWireToInt (wirePassengers) {
  if (!wirePassengers || !wirePassengers.contact || !wirePassengers.contact.length) {
    return [];
  }
  wirePassengers = wirePassengers.contact;
  let intPassengers = [];
  for (let i = 0; i < wirePassengers.length; i++) {
    let wirePassenger = wirePassengers[ i ];
    intPassengers.push(passengerWireToInt(wirePassenger));
  }
  return intPassengers;
}

function passengersIntToWire (intPassengers) {
  let wirePassengers = [];
  for (let i = 0; i < intPassengers.length; i++) {
    let intPassenger = intPassengers[ i ];
    wirePassengers.push(passengerIntToWire(intPassenger));
  }
  return wirePassengers;
}

function passengerWireToInt (wirePassenger) {
  const {
    contact_objectid,
    is_selected,
    fname,
    lname,
    relationship,
    age,
    agestatus,
    is_editable,
    is_infant,
  } = wirePassenger._attributes;
  let selected =
    wirePassenger.is_selected === 'true' || wirePassenger.is_selected === true || false;
  return {
    id: contact_objectid || 0,
    firstName: fname,
    lastName: lname,
    relationship: relationship,
    age: age,
    ageStatus: agestatus,
    editable: is_editable ? !!parseInt(is_editable, 10) : false,
    infant: is_infant ? !!parseInt(is_infant, 10) : false,
    selected: selected,
  };
}

function passengerIntToWire (intPassenger) {
  const { id, selected, seatId } = intPassenger;
  return {
    _contact_objectid: id || 0,
    _selected: selected,
    _SeatAssignmentID: seatId || '',
  };
}



// WEBPACK FOOTER //
// ./src/converter/PassengersConverter.js